export default __webpack_public_path__ + "static/media/wsb-bank.c25cee05.png";